import  routesConfig from './routesConfig';

export default {
    menus: [
        {
            key: " dashboard",
            title: 'Dashboard',
            permission: 'VIEW_DASHBOARD',
            route:null,
            subMenus: null
        },
        {
            key: "disputeManagement",
            title: "Dispute Management",
            permission: "VIEW_DISPUTE_MANAGEMENT",
            route: null,
            subMenus: [
                {
                    key: "newClaim",
                    title: "New Claim",
                    permission: "CREATE_NEW_CLAIM",
                    route: routesConfig.NEW_CLAIM_ROUTE
                },
                {
                    key: "dispute",
                    title: "Disputes",
                    permission: "VIEW_DISPUTES",
                    route: routesConfig.DISPUTES_ROUTE
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/configurations/menuConfig.js